import axios from "axios";
import getToken from "./getToken.js";
const URL = process.env.REACT_APP_BACKEND_USER_URL;

const GetPersonalUserData = async () => {
  const userToken = getToken();
  try {
    const response = await axios.get(URL, {
      headers: {
        token: userToken
      },
    });
    return ({
        username: response.data.user.userName,
        email: response.data.user.email,
        name: response.data.user.name,
        lastName: response.data.user.lastName
    })
  } catch (error) {
    // Es crucial re-lanzar el error para que la función que llama sepa
    // que la operación falló. Retornar el error lo hace parecer un éxito.
    throw error;
  }
};

export default GetPersonalUserData;